import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const getIsCardFromNotification = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return (
        route === ERoutes.ASSIGNED_TO_ME_NOTIFICATION ||
        route === ERoutes.ASSIGNED_TO_ME_NOTIFICATION_ACTIVITY ||
        route === ERoutes.ASSIGNED_TO_ME_NOTIFICATION_TIMING
    );
}
